<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded01"><a id="pagev">
<p class="dedicationTextNoIndent">for Tamyra Heim</p>
<p class="dedicationTextNoIndent">and for Jamie Reisch</p>
<p class="dedicationTextNoIndent"><em class="italic">before, during, after</em></p>
</a><a id="pagevi"></a></div><a id="pagevi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061737190_dedication.vue?ee24f4b4